export const getToastProps=toastIntegration=>toastIntegration?.toast?{disableToastProvider:!0,toastTrigger:toastIntegration.toast}:{disableToastProvider:!1};